// extracted by mini-css-extract-plugin
module.exports = {"tabsRoot":"TabsSolid_tabsRoot__aeN5L","black":"TabsSolid_black__zmV1m","tabsList":"TabsSolid_tabsList__twmn3","tabsTrigger":"TabsSolid_tabsTrigger__NSE8y"};